let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Rz2I")).then(() => parcelRequire('h9uSI'));